import { _ as _sfc_main } from "./VaScrollContainer.vue_vue_type_script_lang-b1e0b683.mjs";
import { openBlock, createElementBlock, normalizeStyle, createElementVNode, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaScrollContainer_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-scroll-container__content" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "va-scroll-container",
    style: normalizeStyle(`--va-0-scroll-color: ${String(_ctx.scrollColor)};--va-1-scrollbar-size: ${String(_ctx.scrollbarSize)};--va-2-overflow-x: ${String(_ctx.overflowX)};--va-3-overflow-y: ${String(_ctx.overflowY)};--va-4-scrollbar-position: ${String(_ctx.scrollbarPosition)}`)
  }, [
    createElementVNode("div", _hoisted_1, [
      renderSlot(_ctx.$slots, "default")
    ])
  ], 4);
}
const _VaScrollContainer = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaScrollContainer as _
};
//# sourceMappingURL=VaScrollContainer-e4626ec4.mjs.map
